import React, { useState, useEffect } from 'react'
import MyPracticeContents from './MyPracticeContents'
import ReduxContainer from '../../../javascript/components_v1/reduxContainer/ReduxContainer'
import UserLoadWrapper from '../../../javascript/components_v1/reduxContainer/UserLoadWrapper'
import camelize from 'camelize'
import {
  difficultyFilterOptions,
  intensityFilterOptions,
  typeFilterOptions
} from '../../components_v1/pageLevelComponents/classFinder/classFinderDropdownInfo'
import { LightTheme } from 'ui/bend'
import { ThemeProvider } from 'styled-components'

const MyPracticeDataLoader = ({ username, selected_tab, ...props }) => {
  const [dataReady, setDataReady] = useState(false)
  const [metaInfo, setMetaInfo] = useState({})

  useEffect(() => {
    const instructorFilterOptions = camelize(props.instructorFilterOptions)
    const categoryFilterOptions = camelize(props.categoryFilterOptions)
    const includeFilters = props.includeFilters
    const defaultOrder = props.defaultOrder

    const metaInfoData = {
      defaultValue: props.defaultValue,
      autopaginate: props.autopaginate,
      includeFilters,
      defaultOrder,
      preloadedFilters: getPreloadedFilters(),
      baseUrl: props.baseUrl,
      withSubcategories: props.withSubcategories,
      dropdownOptions: {
        duration: [],
        instructors: instructorFilterOptions,
        styles: categoryFilterOptions,
        intensities: intensityFilterOptions,
        difficulties: difficultyFilterOptions,
        focus_area: props.planEntryFocusAreaTags,
        equipment: props.planEntryEquipmentTags,
        type: typeFilterOptions
      }
    }
    setDataReady(true)
    setMetaInfo(metaInfoData)
  }, [])

  const getPreloadedFilters = () => {
    const instructors = generateFilteredParams(props.filteredInstructors)
    const styles = generateFilteredParams(props.filteredStyles)
    const difficulties = generateFilteredParams(props.filteredDifficulties)

    const filteredIntensities = generateFilteredParams(
      props.filteredIntensities
    )
    const intensities = filteredIntensities?.map((intensity) =>
      parseInt(intensity, 10)
    )

    const equipment = generateFilteredParams(props.filteredEquipment)

    const focus_area = generateFilteredParams(props.filteredFocusArea)
    const duration = generateFilteredParams(props.duration)
    const excludeCompleted = props.excludeCompleted

    return {
      instructors,
      styles,
      difficulties,
      intensities,
      equipment,
      focus_area,
      duration,
      excludeCompleted
    }
  }

  /**
   * Converts comma separated string of filters to array
   * @param {Comma separated string of filters} filtered
   */
  const generateFilteredParams = (filtered) => {
    return filtered ? filtered.split(',') : []
  }

  return (
    <>
      {dataReady ? (
        <ReduxContainer>
          <UserLoadWrapper>
            <ThemeProvider theme={LightTheme}>
              <MyPracticeContents
                username={username}
                selected_tab={selected_tab}
                {...metaInfo}
              />
            </ThemeProvider>
          </UserLoadWrapper>
        </ReduxContainer>
      ) : null}
    </>
  )
}

export default MyPracticeDataLoader
